import React from "react";
import { connect } from "react-redux";
import { getRoleById } from "../../redux/actions/Roles";
import RemovePermission from "./RemovePermission";
import {
  deletePermissionFromRole,
  getPermissions,
  putPermissionToRole
} from "../../redux/actions/Permissions";
import PermissionsSelect from "./PermissionsSelect";
import "./RolePage.css";

class Role extends React.Component {
  state = {
    permission: ""
  };

  componentWillMount() {
    this.props.getPermissions();
    this.props.getRoleById(this.props.roleId);
  }

  render() {
    const { add, permissions, remove, role } = this.props;

    return (
      <div>
        <h1>Role</h1>
        <p>{role.name}</p>
        <small>
          <i>{role.description}</i>
        </small>
        <p>
          <strong>Permissions</strong>
        </p>
        <form
          className="put-permission-to-role-form"
          onChange={e => {
            this.setState({
              [e.target.name]: e.target.value
            });
          }}
          onSubmit={e => {
            e.preventDefault();
            const permission = permissions.find(permission => {
              return permission.id.toString() === this.state.permissionId;
            });
            add(permission, role);
            this.setState({
              permission: ""
            });
          }}
        >
          <PermissionsSelect
            className="form-control"
            name="permissionId"
            permissions={permissions}
            value={this.state.permissionId}
          />
          <button type="submit" className="btn btn-default">
            Add
          </button>
        </form>
        <table className="table table-sm">
          <tbody>
            {role.permissions.map((permission, key) => (
              <tr key={key}>
                <td>{permission.name}</td>
                <td>
                  <RemovePermission
                    permission={permission}
                    role={role}
                    onClick={() => {
                      remove(permission, role);
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = ({ permissions, roles }, ownProps) => {
  const roleId = ownProps.match.params.id;
  const role = roles.find(role => role.id.toString() === roleId);

  return {
    permissions: permissions.filter(
      permission =>
        role.permissions.find(item => item.id === permission.id) === undefined
    ),
    role,
    roleId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    add: (permission, role) => {
      return dispatch(putPermissionToRole(permission, role));
    },
    getPermissions: () => {
      return dispatch(getPermissions());
    },
    getRoleById: roleId => {
      return dispatch(getRoleById(roleId));
    },
    remove: (permission, role) => {
      return dispatch(deletePermissionFromRole(permission, role));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Role);



// WEBPACK FOOTER //
// ./src/containers/RolePage/RolePage.js